module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Down-2-5e4f1977171ca6ad181dd334e600c8d2.svg";